import Get5ReviewSkills from './Get5ReviewSkills'
export default Get5ReviewSkills
